<template>
  <el-dialog :visible.sync="dialogVisibleValue" @close="closeDialog" width="900px"
             :close-on-click-modal="false"
             title="支出">
    <div class='dialogBody'>
      <el-row :gutter="20" style='margin: 20px 0'>
        <el-col :span='6' class='spanCol'>
          <span>预估支出：</span>
        </el-col>
        <el-col :span='4'>
          <el-select v-model="expensesCycle" size='small'>
            <el-option v-for="item in cycleOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-col>
        <el-col :span='14'>
          <el-input v-model='expenses' size='small'></el-input>
        </el-col>
      </el-row>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ExpensesDialog',
  props: ['dialogVisible', 'params'],
  watch: {
    dialogVisible (val) {
      this.dialogVisibleValue = val
      if (val) {
        this.expenses = this.expensesCycle === 'month' ? this.params[this.blockIndex]["ESTIMATED_SPENDING"] : this.params[this.blockIndex]["ESTIMATED_SPENDING"] * 12
      }
    }
  },
  data() {
    return {
      blockIndex: 0,
      dialogVisibleValue: false,
      expenses: 0,
      expensesCycle: 'month',
      cycleOptions: [{label: '月度', value: 'month'}, {label: '年度', value: 'year'}]
    }
  },
  methods: {
    confirm () {
      const data = {
        "ESTIMATED_SPENDING": this.expensesCycle === 'month' ? this.expenses : this.expenses /12
      }
      this.$emit('dialogConfirm', this.blockIndex, data)
      this.closeDialog()
    },
    closeDialog () {
      this.dialogVisibleValue = false
      this.$emit('dialogVisibleChange', this.dialogVisibleValue)
    },
  }
}
</script>

<style scoped>
.dialogBody {
  max-height: 460px;
  overflow-y: auto;
  font-size: 18px;
}
.spanCol {
  /*text-align: right;*/
}
</style>



// WEBPACK FOOTER //
// src/components/options/ExpensesDialog.vue